module.exports = __webpack_public_path__ + "img/drtheiss.724374a9.svg";